
import React from "react";
import { Filter } from "lucide-react";
import Card from "../common/Card"; // Your actual Card component

export const FilterCard = ({ children, title }) => (
  <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-6">
    <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-4 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
      <div className="relative z-10 flex items-center gap-3">
        <Filter className="w-5 h-5 text-white" />
        <h2 className="text-xl font-bold text-white">{title}</h2>
      </div>
      <div className="absolute -top-4 -right-4 w-12 h-12 bg-white/10 rounded-full"></div>
      <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-white/10 rounded-full"></div>
    </div>
    <div className="p-6">
      {children}
    </div>
  </div>
);